module.exports = __webpack_public_path__ + "static/media/16.1b44268f.jpg";